import script from "./WessexHome.vue?vue&type=script&setup=true&lang=js"
export * from "./WessexHome.vue?vue&type=script&setup=true&lang=js"

import "./WessexHome.vue?vue&type=style&index=0&id=f6062372&lang=scss"

const __exports__ = script;

export default __exports__